import "./Investment.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import NosForfaitsPremium from "./sections/NosForfaitsPremium";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function InvestmentPage() {
  return <div>
      <VoltMainHeader />
      <NosForfaitsPremium />
      <CommonQuestions />
      <Footer />
    </div>;
}